import { Button, InfoLabel, Input, makeStyles, mergeClasses, Text } from '@fluentui/react-components';
import { Column, Row } from '../common';
import { useState } from 'react';
import { Dismiss16Regular, Search16Filled } from '@fluentui/react-icons';
import { useMediaSizes } from '../common/Styles/useMediaSizes';

const useStyles = makeStyles({
    root: {
        minWidth: '230px',
    },
    mobile: {
        maxWidth: '55vw',
        minWidth: 'unset'
    },
    small: {
        height: '28px',
    }
});

type SearchControlProps = {
    placeholder?: string;
    onSearchChange?: (search: string) => void;
    info?: string;
    size?: 'small' | 'medium' | 'large';
};
export const SearchControl = (props: SearchControlProps) => {
    const { placeholder, onSearchChange, info, size } = props;

    const media = useMediaSizes();

    //State
    const [search, setSearch] = useState<string | undefined>('');

    //Styles
    const styles = useStyles();
    const inputClasses = mergeClasses(
        styles.root,
        size === 'small' ? styles.small : undefined,
        media.isMobile ? styles.mobile : undefined
    )

    //Logic
    const onChange = (_ev: React.ChangeEvent<HTMLInputElement>, data: { value: string }) => {
        setSearch(data.value);
        !!onSearchChange && onSearchChange(data.value.trim());
    };
    const clearSearch = () => {
        setSearch('');
        !!onSearchChange && onSearchChange('');
    };

    return (
        <Row width='auto' gap={size === 'small' ? 'medium' : 'large'} noWrap>
            <Column width='auto' vAlign='middle'>
                <Text size={size === 'small' ? 300 : 400} weight='semibold'>
                    Search
                </Text>
            </Column>
            <Column width='auto' vAlign='middle'>
                <InfoLabel info={info} size={size}>
                    <Input
                        value={search || ''}
                        onChange={onChange}
                        className={inputClasses}
                        placeholder={placeholder || 'Search...'}
                        size={size === 'small' ? 'small' : 'medium'}
                        data-testid='search-input'
                        contentBefore={<Search16Filled />}
                        contentAfter={<Button appearance='transparent' icon={<Dismiss16Regular />} onClick={clearSearch} />}
                    />
                </InfoLabel>
            </Column>
        </Row>
    );
};
